import { useEffect } from "react";
import { useStore } from "./store.ts";
import { fetchConfig, fetchHealth, storedKey } from "./api.ts";
import { Library } from "./screens/Library.tsx";
import { Add } from "./screens/Add.tsx";
import { Calibrate } from "./screens/Calibrate.tsx";
import { PickRound } from "./screens/PickRound.tsx";
import { Play } from "./screens/Play.tsx";
import { Results } from "./screens/Results.tsx";

export function App() {
  const screen = useStore((s) => s.screen);

  useEffect(() => {
    void (async () => {
      try {
        const [health, config] = await Promise.all([fetchHealth(), fetchConfig()]);
        useStore.getState().set({
          mode: health!.mode,
          storage: health!.storage,
          uploadsGated: health!.uploadsGated,
          uploadsConfigured: health!.uploadsConfigured,
          maxUploadBytes: health!.maxUploadBytes,
          config: config as never,
          // A stored passphrase is optimistic until a write actually succeeds;
          // it only controls whether the unlock form is shown.
          authed: Boolean(storedKey()),
        });
      } catch {
        /* falls back to the bundled DEFAULT_CONFIG — the app still plays */
      }
    })();
  }, []);

  return (
    <div className="app">
      <header className="brand">
        <h1>catch<span>up!</span></h1>
        <span className="tag">sing-along timing, not pitch</span>
      </header>

      {screen === "library" && <Library />}
      {screen === "add" && <Add />}
      {screen === "calibrate" && <Calibrate />}
      {screen === "pick-round" && <PickRound />}
      {screen === "play" && <Play />}
      {screen === "results" && <Results />}
    </div>
  );
}
